import { useCallback } from 'react';
import { ApiLoginWarning } from 'Constants';
import { SHOW_MODAL } from 'Reducers/modal/types';
import i18n from 'Utilities/i18n';
import { store } from 'Utilities/store';
import { checkEmailVerification } from 'Services/auth';
const useClickContinueEmailVerificationButton = ({
  account_id,
  osType,
  osVersion,
  app,
  appVersion,
  installationId,
  handleApiRequestError,
  signInFunction
}) => {
  const handleContinueEmailVerificationButtonClick = useCallback(async () => {
    try {
      var _authSession$authenti;
      const authSession = await checkEmailVerification({
        account_id,
        osType,
        osVersion,
        app,
        appVersion,
        installationId
      });
      if ((_authSession$authenti = authSession.authentication_steps) !== null && _authSession$authenti !== void 0 && _authSession$authenti.includes(ApiLoginWarning.EMAIL_VERIFICATION)) {
        store.dispatch({
          type: SHOW_MODAL,
          modalProps: {
            header: i18n.t('CheckYourEmailRegistration.modals.verifyEmailDialog.title'),
            details: i18n.t('CheckYourEmailRegistration.modals.verifyEmailDialog.body')
          }
        });
        return;
      }
      signInFunction();
    } catch (err) {
      const error = err;
      handleApiRequestError(error);
    }
  }, [account_id, osType, osVersion, app, appVersion, installationId, signInFunction, handleApiRequestError]);
  return {
    handleContinueEmailVerificationButtonClick
  };
};
export default useClickContinueEmailVerificationButton;